<nz-page-header nzTitle="Tickets Report List"></nz-page-header>

<ng-container  *ngIf="workflow">
	<div class="row">
		<div class="col">
			<a [routerLink]="['/ticket','report',workflow.id,'new']" nz-button nzType="dashed" class="mb-1" >+ New Report</a>
		</div>
		<div class="col">
			<button nz-button nzType="dashed" class="mb-1 float-end ms-2" [disabled]="!(areSomeSelected() || areAllSelected())" (click)="run()">Run Report</button>
			<nz-select class="float-end" style="width: 300px" [ngModel]="workflow" (ngModelChange)="onWorkflowChange($event)" [compareWith]="compareById">
				<nz-option *ngFor="let item of workflows" [nzLabel]="item.name" [nzValue]="item"></nz-option>
			</nz-select>
		</div>
	</div>
	<nz-table nzSize="small" [nzData]="[1]" [nzFrontPagination]="false">
		<thead>
			<tr>
				<th
					class="text-start"
					style="width: 6em"
					[nzChecked]="areAllSelected()"
					[nzIndeterminate]="areSomeSelected()"
					(nzCheckedChange)="setMultipleSelected($event)">
					ID
				</th>
				<th>Name</th>
				<th>Description</th>
			</tr>
		</thead>
		<tbody>
			<tr *ngFor="let item of data" (dblclick)="open(item.payload)">
				<td class="text-start">
					<input type="checkbox" style="transform: scale(1.5);" [(ngModel)]="item.selected" name="report_{{item.payload.id}}" class="me-2"/>
					{{item.payload.id}}
				</td>
				<td>{{item.payload.name}}</td>
				<td>{{item.payload.description}}</td>
			</tr>
		</tbody>
	</nz-table>
</ng-container>
